import React from 'react';
import { STProfileIcon } from './styles';
import { IThemesStore } from "@src/Stores/Themes/types";
import { observer, inject } from "mobx-react";

interface IProps {
    personInitials: string
    themes?: IThemesStore;
}

@observer
@inject("themes")
export default class ProfileIconContainer extends React.Component<IProps> {
    render() {
        return (
            <a>
                <STProfileIcon>{this.props.personInitials}</STProfileIcon>
            </a>
        );
    };
};